export default "__VITE_PUBLIC_ASSET__c5440731__"